import { ApiError, type ProgramSource } from "@/services/adminProgramNews";

type Toast = (opts: {
  title: string;
  description?: string;
  variant?: "default" | "destructive";
}) => unknown;

/** Toasts a failed source mutation; a 403 means the registry is read-only here. */
export function reportSourceError(
  err: unknown,
  toast: Toast,
  failedTitle: string,
  onReadOnly: () => void
): void {
  const message = err instanceof Error ? err.message : String(err);
  if (err instanceof ApiError && err.status === 403) {
    onReadOnly();
    toast({ title: "Read-only in this environment", description: message, variant: "destructive" });
    return;
  }
  toast({ title: failedTitle, description: message, variant: "destructive" });
}

/** The toggle endpoints return the registry row; keep runtime fields the response may omit. */
export function mergeToggledSource(previous: ProgramSource, next: ProgramSource): ProgramSource {
  return { ...previous, ...next };
}
